import o from"../../core/colors/index.js";var r={bgColor:o.grey[200]};export{r as default};
